<div class="ax-avatar__container" [ngClass]="size === 'large' ? 'ax-avatar__container--large' : ''">
    @if (hasImage()) {
        <img class="ax-avatar__image" [src]="imageUrl" alt="avatar"/>
    } @else if (hasName()) {
        <span class="ax-avatar__initials" [ngClass]="size === 'large' ? 'ax-avatar__initials--large' : ''">{{ getInitials() }}</span>
    } @else {
        <span class="ax-avatar__initials" [ngClass]="size === 'large' ? 'ax-avatar__initials--large' : ''"></span>
    }
</div>
